export default "__VITE_ASSET__Cc1tGYKo__"